import {LogMarkerConsts} from '@multipass-common-dto';
import {Markers} from 'esp-js';

export class MarkerUtil {
    #markers: Markers = {};

    public static create(): MarkerUtil {
        return new MarkerUtil();
    }
    
    public appendHttpStatus(value: number): MarkerUtil {
        if (value) {
            this.#markers[LogMarkerConsts.OperationStatusCode] = value.toString();
        }
        return this;
    }

    public appendSessionId(value: string): MarkerUtil {
        if (this.#isStringNotEmpty(value)) {
            this.#markers[LogMarkerConsts.SessionId] = value;
        }
        return this;
    }

    public appendOperationDetails(operationName: string, workflowId: string, correlationId: string, sessionId: string): MarkerUtil {
        this.appendWorkflowId(workflowId)
            .appendCorrelationId(correlationId)
            .appendSessionId(sessionId)
            .appendOperationName(operationName);
        return this;
    }

    public appendOperationName(value: string): MarkerUtil {
        if (this.#isStringNotEmpty(value)) {
            this.#markers[LogMarkerConsts.OperationNane] = value;
        }
        return this;
    }

    public appendWorkflowId(value: string): MarkerUtil {
        if (this.#isStringNotEmpty(value)) {
            this.#markers[LogMarkerConsts.OperationWorkflowId] = value;
        }
        return this;
    }

    public appendCorrelationId(value: string): MarkerUtil {
        if (this.#isStringNotEmpty(value)) {
            this.#markers[LogMarkerConsts.OperationCorrelationId] = value;
        }
        return this;
    }

    public appendError(error: Error): MarkerUtil {
        if (error) {
            this.#markers[LogMarkerConsts.Error] = error.toString();
        }
        return this;
    }


    public getMarker(): Markers {
        return this.#markers;
    }

    #isStringNotEmpty(value: string) {
        return value && value.length > 0;
    }
}
